/**
 * Copyright 2020 New Light Technologies, Inc.
 *
 * With Supporting Sponsorship from the Federal Emergency Management Agency (Contract: GSA Stars II GS-06F-0968Z)
 * In accordance with FAR 52.227-14(c)(iii), New Light Technologies, Inc. grants to the Government and others acting on its behalf a paid-up, nonexclusive, irrevocable, worldwide license in such copyrighted computer software and data to reproduce, prepare derivative works, and perform publicly and display publicly (but not to distribute copies to the public) by or on behalf of the Government.
 * Any other use, distribution, reproduction, modification, or publication without the prior express written authorization of New Light Technologies, Inc. is strictly prohibited.
 * All other rights are reserved by their respective copyright holders.
 *
 */
import { createTheme } from '@mui/material';

export const theme = createTheme({
  palette: {
    primary: {
      light: 'rgb(0, 120, 174)',
      main: 'rgb(0, 82, 136)',
      dark: 'rgb(0, 62, 103)',
      contrastText: '#fff',
    },
    secondary: {
      light: '#fff',
      main: '#fff',
      dark: '#fff',
      contrastText: '#000',
    },
  },
  typography: {
    fontFamily: '"ITC Franklin Gothic", "Source Sans Pro", Open Sans, Arial, Helvetica, sans-serif',
    h5: {
      fontWeight: 400,

      color: 'rgb(0, 82, 136)',
    },

    h6: {
      fontSize: '0.975rem',
      lineHeight: '0.975rem',
      fontWeight: 400,
      color: 'rgb(0, 82, 136)',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          textTransform: 'none',
          fontSize: '1rem',
          borderRadius: 2,
        },
      },
    },
    MuiUseMediaQuery: {
      defaultProps: {
        noSsr: true,
      },
    },
  },
});
